import * as React from 'react';

const DiscoSmallSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} {...props}>
        <path
            d="M11.438 20.25A6.562 6.562 0 0018 13.687a6.562 6.562 0 00-6.563-6.562 6.562 6.562 0 00-6.562 6.563 6.562 6.562 0 006.563 6.562zm0 .75a7.312 7.312 0 007.312-7.313 7.312 7.312 0 00-7.313-7.312 7.312 7.312 0 00-7.312 7.313A7.312 7.312 0 0011.438 21zm0 0"
            fillRule="evenodd"
            fill="#585163"
        />
        <path
            d="M12 5.25h-1.5a.375.375 0 000 .75H12a.375.375 0 000-.75zm-1.5-.75a1.125 1.125 0 000 2.25H12a1.125 1.125 0 000-2.25zm0 0"
            fillRule="evenodd"
            fill="#585163"
        />
        <path
            d="M11.25 3.188c.207 0 .375.167.375.374v1.313a.375.375 0 01-.75 0V3.562c0-.207.168-.374.375-.374zm1.203 15.109c.406-1.195.672-2.89.672-4.797 0-1.906-.266-3.602-.672-4.797-.207-.598-.433-1.031-.648-1.297-.223-.273-.352-.281-.367-.281-.016 0-.145.008-.368.281-.215.266-.441.7-.648 1.297-.406 1.195-.672 2.89-.672 4.797 0 1.906.266 3.602.672 4.797.207.598.433 1.031.648 1.297.223.273.352.281.367.281.016 0 .145-.008.368-.281.215-.266.441-.7.648-1.297zm-1.015 2.328c1.347 0 2.437-3.191 2.437-7.125s-1.09-7.125-2.438-7.125C10.09 6.375 9 9.566 9 13.5s1.09 7.125 2.438 7.125zm0 0"
            fillRule="evenodd"
            fill="#585163"
        />
        <path
            d="M11.438 7.125c-1.301 0-2.508.754-3.383 2.027a.372.372 0 01-.52.098.372.372 0 01-.098-.52c.973-1.421 2.387-2.355 4-2.355 1.547 0 2.915.86 3.883 2.188.97 1.324 1.555 3.136 1.555 5.124 0 1.989-.586 3.801-1.555 5.126C14.352 20.14 12.984 21 11.437 21c-1.546 0-2.914-.86-3.882-2.188C6.585 17.488 6 15.677 6 13.688c0-.519.04-1.027.117-1.519a.376.376 0 01.742.117c-.07.453-.109.922-.109 1.402 0 1.844.547 3.5 1.41 4.684.867 1.188 2.027 1.879 3.277 1.879s2.41-.691 3.278-1.879c.863-1.183 1.41-2.84 1.41-4.683 0-1.844-.547-3.5-1.41-4.684-.867-1.188-2.027-1.879-3.277-1.879zm0 0"
            fillRule="evenodd"
            fill="#585163"
        />
        <path
            d="M4.125 14.25c0-.207.168-.375.375-.375h13.875a.375.375 0 010 .75H4.5a.375.375 0 01-.375-.375zm1.125 3c0-.207.168-.375.375-.375h8.625a.375.375 0 010 .75H5.625a.375.375 0 01-.375-.375zm3-6.375c0-.207.168-.375.375-.375h9a.375.375 0 010 .75h-9a.375.375 0 01-.375-.375zm0 0"
            fillRule="evenodd"
            fill="#585163"
        />
        <path
            d="M7.5 10.875a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0"
            fill="#585163"
        />
        <path
            d="M17.438 3.75c.207 0 .375.168.375.375 0 1.059.757 1.5 1.312 1.5a.375.375 0 010 .75c-.555 0-1.313.441-1.313 1.5a.375.375 0 01-.75 0c0-1.059-.757-1.5-1.312-1.5a.375.375 0 010-.75c.555 0 1.313-.441 1.313-1.5 0-.207.167-.375.375-.375zm0 1.703a2.04 2.04 0 01-.536.547c.203.14.387.324.535.547A2.04 2.04 0 0117.974 6a2.04 2.04 0 01-.535-.547zm0 0"
            fillRule="evenodd"
            fill="#585163"
        />
    </svg>
);

DiscoSmallSvg.displayName = 'DiscoSmallSvg';
export default DiscoSmallSvg;
